module.exports = __webpack_public_path__ + "img/logo.51a38b82.svg";